import * as React from 'react';

import { SMALL_ICON_BASE_SRC } from '../../../../Shared/index';

export const SECTION_CARD_LIMIT = 3

function hidesCard(cards: React.ReactNode[], cardKey?: string | null): boolean {
  if (!cardKey) { return false }
  return cards.findIndex(card => React.isValidElement(card) && card.key === cardKey) >= SECTION_CARD_LIMIT
}

export const TruncatedCardGrid = ({ cards, trailingCard, itemLabel = 'activity packs', revealCardKey }: { cards: React.ReactNode[], trailingCard?: React.ReactNode, itemLabel?: string, revealCardKey?: string | null }) => {
  const [showAll, setShowAll] = React.useState(() => hidesCard(cards, revealCardKey))
  const toggleRef = React.useRef<HTMLButtonElement>(null)
  const toggleTopBeforeCollapse = React.useRef<number | null>(null)
  const visible = showAll ? cards : cards.slice(0, SECTION_CARD_LIMIT)

  function toggleShowAll() {
    if (showAll && toggleRef.current) { toggleTopBeforeCollapse.current = toggleRef.current.getBoundingClientRect().top }
    setShowAll(!showAll)
  }

  React.useLayoutEffect(() => {
    if (toggleTopBeforeCollapse.current === null || !toggleRef.current) { return }
    window.scrollBy(0, toggleRef.current.getBoundingClientRect().top - toggleTopBeforeCollapse.current)
    toggleTopBeforeCollapse.current = null
  }, [showAll])
  return (
    <React.Fragment>
      <div className="pack-card-grid">
        {visible}
        {trailingCard}
      </div>
      {cards.length > SECTION_CARD_LIMIT && (
        <button className="quill-button small outlined green section-show-all focus-on-light" onClick={toggleShowAll} ref={toggleRef} type="button">
          {showAll ? `Show fewer ${itemLabel}` : `Show all ${cards.length} ${itemLabel}`}
        </button>
      )}
    </React.Fragment>
  )
}

export const sectionIcon = (name: string) => <img alt="" src={`${SMALL_ICON_BASE_SRC}/${name}.svg`} />

export const sectionBoltIcon = <img alt="" src={`${SMALL_ICON_BASE_SRC}/bolt.svg`} />

export const Section = ({ id, title, icon, children }: { id: string, title: string, icon?: React.ReactNode, children: React.ReactNode }) => (
  <section className="pack-section" id={id}>
    <div className="pack-section-header">
      <h2>{icon}{title}</h2>
    </div>
    {children}
  </section>
)

export const noResultsIcon = <img alt="" height="28" src={`${SMALL_ICON_BASE_SRC}/search.svg`} width="28" />

export interface NoResultsStateProps {
  header: string;
  text?: string;
  showReset?: boolean;
  onReset?: () => void;
  cta?: { text: string, href: string };
  icon?: React.ReactNode;
  plain?: boolean;
}

export const NoResultsState = ({ header, text, showReset, onReset, cta, icon, plain }: NoResultsStateProps) => (
  <div className={`no-results-state ${plain ? 'no-results-state--plain' : ''}`}>
    <div className="no-results-icon">{icon || noResultsIcon}</div>
    <h3>{header}</h3>
    {text && <p>{text}</p>}
    {cta && <a className="quill-button contained small green focus-on-light" href={cta.href}>{cta.text}</a>}
    {showReset && (
      cta
        ? <button className="interactive-wrapper no-results-reset focus-on-light" onClick={onReset} type="button">Reset filters</button>
        : <button className="quill-button outlined small green focus-on-light" onClick={onReset} type="button">Reset filters</button>
    )}
  </div>
)

export const createPackCard = (
  <section className="create-pack-card" key="create-pack">
    <span aria-hidden="true" className="create-pack-icon">+</span>
    <h3>Create your own activity pack</h3>
    <p>Select from over 1,000 activities created by Quill, or start from a pre-made pack.</p>
    <div className="create-pack-buttons">
      <a className="quill-button contained small green focus-on-light" href="/assign/activity-library">Get started</a>
      <a className="quill-button outlined small green focus-on-light" href="/assign/featured-activity-packs">Browse pre-made packs</a>
    </div>
  </section>
)
